// client/src/utils/socket.js

import { io } from 'socket.io-client';

// DUAL SOCKET CONFIGURATION
// Conectarse a AMBOS backends simultáneamente para recibir eventos de ambos
const SOCKET_URLS = {
  it: 'https://waserver.life5.it',
  es: 'https://waserver.life5.es'
};

let sockets = {
  it: null,
  es: null
};

function createSocket(serverKey, url) {
  const token = localStorage.getItem('token');
  const s = io(url, {
    auth: { token },
    path: '/socket.io',
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    withCredentials: true,
    pingInterval: 5000,
    pingTimeout: 60000
  });

  s.on('connect', () => console.log(`[Socket:${serverKey}] ✅ conectado a ${url}`, s.id, new Date()));
  s.on('disconnect', reason => console.log(`[Socket:${serverKey}] ❌ desconectado`, reason, new Date()));
  s.on('reconnect', attempt => {
    console.log(`[Socket:${serverKey}] 🔄 re-conectado tras intento`, attempt);
  });
  s.on('connect_error', e => console.error(`[Socket:${serverKey}] ⚠️ error`, e));
  s.on('ping', () => console.log(`[Socket:${serverKey}] 🏓 pong ${new Date()}`));

  // Debug: Escuchar todos los eventos de conversationUpdated
  s.onAny((eventName, ...args) => {
    if (eventName === 'conversationUpdated') {
      console.log(`[Socket:${serverKey}] 📨 conversationUpdated recibido:`, args);
    }
  });

  return s;
}

export function initSocket() {
  if (!sockets.it) {
    console.log('[Socket] Inicializando conexiones duales a ambos backends...');
    sockets.it = createSocket('IT', SOCKET_URLS.it);
    sockets.es = createSocket('ES', SOCKET_URLS.es);
  }
  // Retornar el socket IT por compatibilidad (la mayoría de eventos llegarán por ambos)
  return sockets.it;
}

/**
 * getSocket() retorna el socket principal (IT) por compatibilidad
 * pero en realidad ambos sockets están escuchando
 */
export function getSocket() {
  if (!sockets.it) {
    console.warn('[Socket] initSocket no fue llamado; inicializándolo ahora.');
    initSocket();
  }
  return sockets.it;
}

/**
 * Nuevo: Obtener ambos sockets para registrar listeners en ambos
 */
export function getSockets() {
  if (!sockets.it || !sockets.es) {
    console.warn('[Socket] Sockets no inicializados; inicializándolos ahora.');
    initSocket();
  }
  return sockets;
}

/**
 * Registrar un listener en AMBOS sockets
 * Esto asegura que recibamos eventos de ambos backends
 */
export function onBothSockets(eventName, callback) {
  const { it, es } = getSockets();
  it.on(eventName, callback);
  es.on(eventName, callback);
}
